import { types } from '../constants';

const countryService = {
  getCurrentRegion() {
    const adminCountry = window.localStorage.getItem('adminCountryType');
    if (adminCountry) return adminCountry;

    const countryType = window.localStorage.getItem('countryType');
    return countryType || types.countryType.GREAT_BRITAIN;
  },

  isScotland() {
    return this.getCurrentRegion() === types.countryType.SCOTLAND;
  },

  isGreatBritain() {
    return this.getCurrentRegion() === types.countryType.GREAT_BRITAIN;
  },
};

export default countryService;
